export const getters = {
    cardId(state) {
        return state.card_id;
    },
};

export default getters;
